import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import store from '@/store/index'
import uiControll from '@/store/uiControll'
import getCsrfToken from '@/store/Csrf'
import { commonUtil } from '@/util'

import request from './request'

import requestSaleCompleteRegister from './request/requestSaleCompleteRegister'
import requestSalesCompleteRegister from './request/requestSalesCompleteRegister'
import requestSalePaymentRegister from './request/requestSalePaymentRegister'
import requestSalesPaymentRegister from './request/requestSalesPaymentRegister'
import requestRacknumberByProduct from './request/requestRacknumberByProduct'
import requestSaleEdit from './request/requestSaleEdit'
import orderReason from '@/config/order/orderReason'
import { dateFormatYYYYMMDD } from '@/mixins/format'

const Actions = {
  // SA01 販売登録
  registerSale: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = request.request.createRequest(params)

    const ret = await axios
      // .get(apiMock.SALE_REGISTER_EDIT, params)
      .post(api.SALE_REGISTER_EDIT, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)

        return false
      })
    return ret
  },
  // SH01 販売履歴一覧取得
  getSaleListFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const ret = await axios
      // .get(apiMock.SALE_HISTORY, params)
      .get(api.SALE_HISTORY, { params: params })
      .then((response) => {
        const path = mutationsTypes.SALE_SET_SALE_HISTORY
        commit(path, response.data)

        // ページャーをセット
        const pagePath = mutationsTypes.UI_SET_PAGE_COUNT
        const pageCount = commonUtil.getPageCount(
          response.data.meta.totalRows,
          response.data.meta.perPage
        )
        commit(
          `UI/${pagePath}`,
          { length: pageCount, key: 'salesHistory' },
          { root: true }
        )

        const getData = getters.getSaleListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // uiControll.commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)

        return false
      })
    return ret
  },
  // SH09 注文完成
  registerSaleComplete: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestSaleCompleteRegister.request.createRequest(params)
    const ret = await axios
      // .get(apiMock.SALE_COMPLETE)
      .patch(`${api.SALE_COMPLETE}/${params.id}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
    return ret
  },
  // SH02 入金履歴取得
  getSalePaymentListFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const ret = await axios
      // .get(apiMock.SALE_PAYMENT_LIST)
      .get(`${api.SALE_PAYMENT_LIST}/${params.id}`)
      .then((response) => {
        const path = mutationsTypes.SALE_SET_SALE_PAYMENT_LIST
        commit(path, response.data.data)
        const getData = getters.getSalePaymentListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // uiControll.commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
    return ret
  },
  // SH03 入金操作
  registerSalePayment: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestSalePaymentRegister.request.createRequest(params)
    const ret = await axios
      // .get(apiMock.SALE_PAYMENT_OPERATION)
      .post(`${api.SALE_PAYMENT_OPERATION}/${params.id}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
    return ret
  },
  // SH04 入金キャンセル
  cancelSalePayment: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    salePaymentId
  ) => {
    await getCsrfToken()
    const ret = await axios
      // .get(apiMock.SALE_PAYMENT_CANCEL)
      .patch(`${api.SALE_PAYMENT_CANCEL}/${salePaymentId}`)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
    return ret
  },
  // SH06 商品毎棚番号取得
  getRackNumberByProductFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const req = requestRacknumberByProduct.request.createRequest(params)

    const ret = await axios
      // .get(apiMock.SALE_RACKNUMBER_BY_PRODUCT, params)
      .get(`${api.SALE_RACKNUMBER_BY_PRODUCT}/${params.storageId}`, {
        params: req
      })
      .then((response) => {
        const path = mutationsTypes.SALE_SET_RACKNUMBER_BY_PRODUCT
        commit(path, response.data.data)

        const getData = getters.getRackNumberByPaymentFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // uiControll.commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
      })
    return ret
  },
  // SH15 一括入金操作
  registerSalesPayment: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestSalesPaymentRegister.request.createRequest(params)
    const ret = await axios
      // .get(apiMock.SALE_PAYMENT_OPERATION)
      .post(api.SALE_PAYMENT_OPERATION_LIST, req)
      .then((response) => {
        const path = mutationsTypes.SALE_BULK_OPERATION_FLG
        commit(path, true)
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
      .finally(() => {
        const path = mutationsTypes.SALE_BULK_OPERATION_FLG
        commit(path, false)
      })
    return ret
  },
  // SH16 一括注文完成
  registerSalesComplete: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestSalesCompleteRegister.request.createRequest(params)
    const ret = await axios
      .post(api.SALE_COMPLETE_LIST, req)
      .then((response) => {
        const path = mutationsTypes.SALE_BULK_OPERATION_FLG
        commit(path, true)
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
      .finally(() => {
        const path = mutationsTypes.SALE_BULK_OPERATION_FLG
        commit(path, false)
      })
    return ret
  },
  // SHE02 注文修正
  editSale: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestSaleEdit.request.createRequest(params)
    const ret = await axios
      // .get(apiMock.SALE_REGISTER_EDIT)
      .patch(`${api.SALE_REGISTER_EDIT}/${params.id}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
    return ret
  },
  // SH10 注文完成キャンセル
  cancelSaleComplete: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const ret = await axios
      // .get(apiMock.SALE_COMPLETE_CANCEL)
      .patch(`${api.SALE_COMPLETE_CANCEL}/${params.id}`)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
    return ret
  },
  // SH13 注文キャンセル
  cancelSale: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const ret = await axios
      // .get(apiMock.SALE_CANCEL)
      .patch(`${api.SALE_CANCEL}/${params.id}`)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
    return ret
  },
  // SHE01 販売詳細取得
  getSaleDetailFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const ret = await axios
      .get(api.SALE_DETAIL, { params: params })
      .then((response) => {
        const path = mutationsTypes.SALE_SET_SALE_DETAIL
        commit(path, response.data.data)

        const getData = getters.getSaleDetailFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // uiControll.commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
      })
    return ret
  },
  // SH12 注文備考編集
  editSaleNote: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const ret = await axios
      .patch(`${api.SALE_NOTE_EDIT}/${params.id}`, params)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
    return ret
  },
  // OH17 注文一括キャンセル
  bulkCancelSale: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const ret = await axios
      .post(`${api.SALE_BULK_CANCEL}`, params)
      .then((response) => {
        return response.data.errors
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return null
      })
    return ret
  },
  // SH19 販売履歴一覧CSV
  sendMailSalesCSV: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const ret = await axios
      .get(api.SALE_SEND_MAIL_SALES_CSV, { params: params })
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
    return ret
  },
  getOrderIncompleteListFromApi: async (
      { state, dispatch, commit, getters, rootGetters, rootState },
      params
  ) => {
    // TODO Need update api path after merged API
    return await axios
        .get(`${api.ORDER_INCOMPLETE_LIST}/${params.saleId}`)
        .then((response) => {
          const path = mutationsTypes.ORDER_SET_ORDER_INCOMPLETE_LIST
          const orderIncompleteList = response.data.data.notificationList
          return orderIncompleteList.map((item) => {
            const lastname = item.user.lastName ? item.user.lastName : ''
            const firstname = item.user.firstName ? item.user.firstName : ''
            const fullName = lastname ? `${lastname} ${firstname}` : firstname

            const orderReasonKey = Object.keys(
                orderReason.ORDER_REASON_TYPE_ID
            ).find((key) => orderReason.ORDER_REASON_TYPE_ID[key] === item.type)
            const orderReasonLabel =
                orderReason.ORDER_REASON_TYPE_LABEL[orderReasonKey]

            const created_at_formatted = dateFormatYYYYMMDD(item.created_at)
            item.user = {
              ...item.user,
              fullName
            }
            return {
              ...item,
              orderReason: orderReasonLabel,
              created_at_formatted: created_at_formatted
            }
          })
        })
        .catch((error) => {
          commonUtil.afterApiFailProcess(error.response)
          return false
        })
  },
  deleteIncompleteNotification: async (
      { state, dispatch, commit, getters, rootGetters, rootState },
      params
  ) => {
    return await axios
        .patch(
            `${api.SALE_DELETE_INCOMPLETE_NOTIFICATION}/${params.saleId}/resolve-incomplete/${params.notificationId}`
        )
        .then((response) => {
          return true
        })
        .catch((error) => {
          // commonErrorControl(error.response)
          commonUtil.afterApiFailProcess(error.response)
          return false
        })
  },
  unresolveIncompleteNotification: async (
      { state, dispatch, commit, getters, rootGetters, rootState },
      params
  ) => {
    return await axios
        .patch(
            `${api.SALE_DELETE_INCOMPLETE_NOTIFICATION}/${params.saleId}/unresolve-incomplete/${params.notificationId}`
        )
        .then((response) => {
          return true
        })
        .catch((error) => {
          // commonErrorControl(error.response)
          commonUtil.afterApiFailProcess(error.response)
          return false
        })
  },
  confirmOrder: async (
      { state, dispatch, commit, getters, rootGetters, rootState },
      params
  ) => {
    return await axios
        .post(`${api.SALE_ORDER_CONFIRM}/${params}`)
        .then((response) => {
          return true
        })
        .catch((error) => {
          commonUtil.afterApiFailProcess(error.response)
          return false
        })
  },
  cancelConfirmOrder: async (
      { state, dispatch, commit, getters, rootGetters, rootState },
      params
  ) => {
    return await axios
        .post(`${api.SALE_ORDER_CANCEL_CONFIRM}/${params}`)
        .then((response) => {
          return true
        })
        .catch((error) => {
          commonUtil.afterApiFailProcess(error.response)
          return false
        })
  },
  shipmentDelivery: async (
      { state, dispatch, commit, getters, rootGetters, rootState },
      params
  ) => {
    return await axios
        .post(`${api.SALE_SHIPMENT_DELIVERY}/${params.saleId}`, params)
        .then((response) => {
          return true
        })
        .catch((error) => {
          // commonErrorControl(error.response)
          commonUtil.afterApiFailProcess(error.response)

          return false
        })
  }
}

export default Actions
